<template>
  <div id="data-list-list-view" class="data-list-container vs-con-loading__container">
    <Form :isOpen="openModal" @closeModal="closeModal()" @submitModal="submitModal()" :title="titleModal"
      :id="selectedAlertId" :imei="selectedAlertImei" :editMode="editMode" :dataEdit="dataEdit"></Form>

    <FormDetail :isOpen="openModalDetail" @closeModal="closeModal()" @submitModal="submitModal()"
      :title="titleModalDetail" :id="selectedAlertId" :imei="selectedAlertImei" :editMode="editModeDetail"
      :dataEdit="dataEditDetail"></FormDetail>

    <div class="justify-end flex flex-wrap items-center mb-2" style="gap: 15px">
      <div class="flex flex-row items-center" style="gap: 10px">
        <label for="license_plate">License Plate</label>
        <div style="background: white; min-width: 200px; width: auto">
          <v-select class="drop-height-auto" placeholder="- Select License Plate -" :clearable="true"
            v-model="selected_plate" label="text" :options="plate_array" />
        </div>
      </div>
      <div class="flex flex-row items-center" style="gap: 10px">
        <label for="license_plate">Amount of Data</label>
        <!-- @input-change="autoCompleteFunc" -->
        <vs-select autocomplete class="lnData" v-model="itemsPerPage" width="60px" @input="showDataCount">
          <vs-select-item :key="index" :value="item.value" :text="item.text"
            v-for="(item, index) in itemsPerPageArray" />
        </vs-select>
        <!-- <v-select
          width="60px"
          style="background: white"
          @input="(x) => (itemsPerPage = x.value)"
          :clearable="false"
          :value="getSelectValue(itemsPerPage, itemsPerPageArray)"
          :reduce="(text) => text.value"
          label="text"
          :options="itemsPerPageArray" /> -->
      </div>
      <!-- <div class="flex flex-row items-center" style="gap: 10px">
        <label for="license_plate">Sort by</label>
        <vs-select autocomplete class="lnData" v-model="sortBy" width="120px">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in sortByArray" />
        </vs-select>
      </div> -->
      <div class="p-5 flex flex-col rounded-lg border" style="gap: 20px; width: 100%; background: white; margin-bottom: 20px;">
        <div class="flex flex-col" style="gap: 10px">
          <h4>Filter</h4>
          <p>
            Filter each to able to see specific fleet group date and also
            violation
          </p>
        </div>
        <div class="flex flex-row w-full" style="gap: 10px">
          <div class="flex flex-col w-full" style="gap: 8px">
            <label class="font-semibold" for="">From</label>
            <div class="datetimepicker">
              <div class="custom-datetime-wrapper">
                <input
                  type="date"
                  class="custom-date-input"
                  v-model="startDateInput"
                  :min="minStartDate"
                  :max="maxStartDate" />
                <div class="custom-time-picker" @click="openTimePicker('start')">
                  <span class="time-display">{{ displayStartTime }}</span>
                  <svg
                    class="clock-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col w-full" style="gap: 8px">
            <label class="font-semibold" for="">To</label>
            <div class="datetimepicker">
              <div class="custom-datetime-wrapper">
                <input
                  type="date"
                  class="custom-date-input"
                  v-model="endDateInput"
                  :min="endDateMin"
                  :max="endDateMax" />
                <div class="custom-time-picker" @click="openTimePicker('end')">
                  <span class="time-display">{{ displayEndTime }}</span>
                  <svg
                    class="clock-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <label class="font-semibold" for="fleet_group">Fleet Group</label>
          <v-select placeholder="- Fleet Group -" style="background: white"
            @input="(x) => (selected_fleet = x.value)" :clearable="false"
            :value="getSelectValue(selected_fleet, fleetData)" :reduce="(text) => text.value" label="text"
            :options="fleetData_t" />
        </div>
        <div>
          <label class="font-semibold" for="license_plate">Status Alert</label>
          <v-select style="background: white" placeholder="- Select Status Alert -"
            @input="(x) => (status_type = x.value)" :clearable="false"
            :value="getSelectValue(status_type, status_list)" :reduce="(text) => text.value" label="text"
            :options="status_list_t" />
        </div>
        <div>
          <label class="font-semibold" for="license_plate">Type of Event</label>
          <v-select style="background: white" placeholder="- Select Event Type -"
            @input="(x) => (event_type = x.value)" :clearable="false"
            :value="getSelectValue(event_type, event_list)" :reduce="(text) => text.value" label="text"
            :options="event_list_t" />
        </div>
        <div class="flex flex-row mt-4 mb-1" style="gap: 10px">
          <vs-button class="py-3 px-10 ml-auto" type="border" @click="resetData">Clear</vs-button>
        </div>
      </div>
      <vs-button v-if="getRolePermission().alert.alert_history.enable_download" class="py-2 px-4 btn-download"
        color="danger" type="border" @click="download_data">
        <div class="flex flex-row">
          <p class="mr-4 font-medium">Download</p>
          <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4"></feather-icon>
        </div>
      </vs-button>
      <vs-button radius color="danger" type="filled" @click="refreshData"><feather-icon icon="RefreshCwIcon"
          svgClasses="h-4 w-5"></feather-icon></vs-button>
    </div>
    <!-- <div id="loading-container" class="w-full"></div> -->
    <vs-table ref="table" :max-items="itemsPerPage" :data="data">
      <template slot="thead">
        <vs-th>{{ $t('COUNT') }}</vs-th>
        <vs-th>{{ $t('LICENSE PLATE') }}</vs-th>
        <vs-th>{{ $t('FLEET GROUP') }}</vs-th>
        <vs-th>{{ $t('ALERT') }}</vs-th>
        <vs-th>{{ $t('DRIVER NAME') }}</vs-th>
        <!-- <vs-th>{{ $t('DRIVER PHONE') }}</vs-th> -->
        <vs-th>{{ $t('SPEED') }}</vs-th>
        <vs-th>{{ $t('DURATION') }}</vs-th>
        <vs-th>{{ $t('LOCATION') }}</vs-th>
        <vs-th>{{ $t('ACTION') }}</vs-th>
        <vs-th>{{ $t('DETAIL') }}</vs-th>
        <!-- <vs-th style="width: 204px">Status</vs-th> -->
      </template>
      <template slot-scope="{ data }">
        <tbody id="isi_table">
          <vs-tr :id="tr._id" class="cursor-default" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].count">
              <p class="product-name font-medium">{{ tr.count }}</p>
            </vs-td>
            <vs-td :data="data[indextr].license_plate">
              <a :href="`/monitoring-vehicle/${data[indextr].vehicle_id}`">
                <p class="product-name font-medium">
                  {{ tr.license_plate }}
                </p>
              </a>
            </vs-td>
            <vs-td :data="data[indextr].fleet_group_name">
              <p class="product-name font-medium">{{ tr.fleet_group_name }}</p>
            </vs-td>
            <vs-td :data="data[indextr].event_name">
              <p class="product-name font-medium">{{ $t(tr.event_name) }}</p>
            </vs-td>
            <vs-td :data="data[indextr].driver_name">
              <p class="product-name font-medium">
                {{ tr.driver_name ? tr.driver_name : '-' }}
              </p>
            </vs-td>
            <!-- <vs-td :data="data[indextr].driver_phone">
              <p class="product-name font-medium">
                {{ tr.driver_phone ? tr.driver_phone : '-' }}
              </p>
            </vs-td> -->
            <vs-td :data="data[indextr].speed">
              <p class="product-name font-medium">{{ tr.speed }} Km/h</p>
            </vs-td>
            <vs-td :data="data[indextr].speed">
              <p class="product-name font-medium">-</p>
            </vs-td>
            <vs-td class="py-2" :data="data[indextr].location">
              <p class="product-name font-medium">-</p>
              <!-- <a target="_blank" :href="tr.gmaps_url">Show Google Map</a>
              <br />
              <a target="_blank" :href="tr.streetview_url">Show Street View</a> -->
            </vs-td>
            <vs-td class="py-2 relative" :data="data[indextr].verified_by">
              <div>
                <div
                  class="z-10 font-semibold items-center py-2 px-5 my-1 justify-center flex rounded-lg w-fit cursor-pointer"
                  :style="{
                    'background-color':
                      tr.verified_by.type === 'danger' ||
                        tr.verified_by.type === 'success'
                        ? 'transparent'
                        : `var(--${tr.verified_by.type})`,
                    color: `var(--${tr.verified_by.type}-content)`,
                    width: 'fit-content',
                  }" @click="handleSelected(tr)">
                  <feather-icon :icon="tr.verified_by.icon" svgClasses="h-8 w-8"></feather-icon>
                  <p v-if="tr.verified_by.type == 'danger'" class="text-center ml-2">
                    {{ $t('Not Verified') }}
                  </p>
                  <p v-else-if="tr.verified_by.type == 'success'" class="text-center ml-2">
                    {{ $t('Verified by') }} <br />
                    {{ tr.verified_by.name }}
                  </p>
                  <p v-else class="text-center ml-2">
                    {{ $t('Verification') }} <br />
                    {{ $t('Required') }}
                  </p>
                </div>
                <span v-show="hideBtn == tr._id" style="color: #1c44a3; font-size: 12px">
                  Verifying ...
                </span>
              </div>
            </vs-td>
            <vs-td class="py-2" :data="data[indextr].note">
              <p class="text-danger underline cursor-pointer" @click="handleDetails(tr)">
                see details
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div v-if="showTimePicker" class="time-picker-overlay" @click="closeTimePicker">
      <div class="time-picker-modal" @click.stop>
        <div class="time-picker-header">
          <h3>Select Time</h3>
          <button class="close-btn" @click="closeTimePicker">&times;</button>
        </div>
        <div class="time-picker-body">
          <div class="time-scroll-container">
            <div class="time-column">
              <div class="time-column-header">Hour</div>
              <div class="time-scroll" ref="hourScroll">
                <div
                  v-for="hour in hours"
                  :key="hour"
                  class="time-item"
                  :class="{ active: selectedHour === hour }"
                  @click="selectHour(hour)">
                  {{ hour }}
                </div>
              </div>
            </div>
            <div class="time-separator">:</div>
            <div class="time-column">
              <div class="time-column-header">Minute</div>
              <div class="time-scroll" ref="minuteScroll">
                <div
                  v-for="minute in minutes"
                  :key="minute"
                  class="time-item"
                  :class="{ active: selectedMinute === minute }"
                  @click="selectMinute(minute)">
                  {{ minute }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="time-picker-footer">
          <button class="time-btn time-btn-cancel" @click="closeTimePicker">Cancel</button>
          <button class="time-btn time-btn-confirm" @click="confirmTime">Confirm</button>
        </div>
      </div>
    </div>

    <template>
      <vs-pagination :total="last_page" v-model="page"></vs-pagination>
    </template>
  </div>
</template>

<script>
import * as moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/database'
import { mapState } from 'vuex'
import * as REPO from '../../../repository/index'
import XLSX from 'xlsx'
import Form from './VerifyForm.vue'
import FormDetail from './VerifyFormDetail.vue'
import { VideoIcon, ImageIcon } from 'vue-feather-icons'


export default {
  components: {
    Form,
    FormDetail,
    VideoIcon,
    ImageIcon
  },
  props: {},
  watch: {
    page(val) {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    selected_plate(val) {
      if (val == null) {
        this.search_name = ''
        this.searchData()
      } else {
        this.search_name = val.text
        this.searchData()
      }
    },
    startDateInput() {
      if (this.suppressStartInputWatcher) return
      this.updateStartFromInputs()
    },
    startTimeInput() {
      if (this.suppressStartInputWatcher) return
      this.updateStartFromInputs()
    },
    endDateInput() {
      if (this.suppressEndInputWatcher) return
      this.updateEndFromInputs()
    },
    endTimeInput() {
      if (this.suppressEndInputWatcher) return
      this.updateEndFromInputs()
    },
    dateStart(val) {
      this.syncStartInputsFromDate(val)

      if (!val) {
        this.maxEnd = null
        return
      }

      const maxCandidate = moment(val).add(14, 'days')
      const now = moment()
      const maxEndMoment = now.isBefore(maxCandidate) ? now : maxCandidate

      this.maxEnd = maxEndMoment.format('YYYY-MM-DD HH:mm:ss')
      this.dateEnd = this.maxEnd
      this.filterData()
    },
    dateEnd(val) {
      this.syncEndInputsFromDate(val)
      this.filterData()
    },
    selected_fleet(val) {
      this.filterData()
    },
    status_type(val) {
      this.filterData()
    },
    event_type(val) {
      this.filterData()
    },
  },
  mounted() {
    this.generateTimeOptions()
    this.getFilterData()
    var self = this
    let start = moment().format('YYYY-MM-DD') + ' 00:00:00'
    this.dateStart = start
    let ends = moment().format('YYYY-MM-DD HH:mm:ss')

    setTimeout(() => {
      const inputs = document.getElementsByTagName('input')
      const input = Array.from(inputs).find(
        (x) => x['placeholder'] == '- Select License Plate -'
      )
      //
      input.removeEventListener('keydown', self.onKeyDownLicense, true)
      input.addEventListener('keydown', self.onKeyDownLicense, true)
      input.addEventListener(
        'keyup',
        (e) => (e.target.value = e.target.value.toUpperCase()),
        true
      )
    }, 500)

    this.$root.$on('reloadNotifBawah', () => {
      //
      this.resetData()
    })

    this.$root.$on('refreshSummary', (val) => {
      //
      this.fleet_group_id = val.fleet_group_id
      this.selected_fleet = val.fleet_group_id
      this.dateStart = val.start_date
      this.dateEnd = val.end_date
      this.event_type = val.event_type
      setTimeout(() => {
        this.refreshData()
      }, 200)
    })
    let role = JSON.parse(localStorage.getItem('userInfo')).role.role_menu
    //
    let url = this.$router.currentRoute.path
    let check = role.filter((x) => x.menu_link == url)
    //
    if (check.length > 0) {
      if (check[0].is_update == 0) {
        this.disableBtn = true
      }
    }
    //
    // menu_link
    REPO.getListAlert().then((res) => {
      let tmp = res.data.data
      this.event_list = [
        {
          text: 'All',
          value: '',
        },
      ]
      tmp.forEach((x) => {
        // Cek apakah huruf pertama adalah huruf kecil, kalau iya berati alert dashcam
        const isFirstLetterLowercase = /^[a-z]/.test(x.alert_code);

        this.event_list.push({
          text: isFirstLetterLowercase ? "DASHCAM - " + x.alert_name : x.alert_name,
          value: x.alert_code,
        })
      })
    })
    this.selected_fleet = self.$dataLocal.UserData().id

    this.filter_array = [
      {
        text: 'License Plate',
        value: 'license_plate',
      },
      {
        text: 'IMEI',
        value: 'imei_obd_number',
      },
    ]
    // self.$vs.loading.close('#data-list-list-view > .con-vs-loading');
    this.fleet_group_id = this.$dataLocal.UserData().id
    this.fleetData = [
      {
        text: 'All',
        value: this.$dataLocal.UserData().id,
      },
    ]
    REPO.getListFleetChield(this.$dataLocal.UserData().id).then((res) => {
      if (res.data.status == 'true') {
        let tmp = res.data.data.map((h) => {
          return {
            text: h.fleet_group_name,
            value: h.id,
          }
        })
        // let hasil = []
        // this.rekursive(tmp, hasil, 0)
        //
        this.fleetData = [...this.fleetData, ...tmp]
        let end_date = moment().format('YYYY-MM-DD HH:mm:ss')
        this.getData({
          event_type: this.event_type,
          limit: this.itemsPerPage,
          page: 1,
          fleet_group_id: self.selected_fleet,
          start_date: this.dateStart,
          end_date: end_date,
          status_verified: this.status_type,
        })
      }
    })

    this.maxEnd = ends
    this.dateEnd = ends
    setTimeout(() => {
      this.dateEnd = ends
      //
    }, 2500)
  },
  computed: {
    ...mapState(['notifData']),
    displayStartTime() {
      return this.startTimeInput || '00:00'
    },
    displayEndTime() {
      return this.endTimeInput || '00:00'
    },
    minStartDate() {
      return moment().subtract(4, 'months').format('YYYY-MM-DD')
    },
    maxStartDate() {
      return moment().format('YYYY-MM-DD')
    },
    endDateMin() {
      return this.startDateInput || this.minStartDate
    },
    endDateMax() {
      if (!this.maxEnd) {
        return this.maxStartDate
      }
      const max = moment(this.maxEnd, 'YYYY-MM-DD HH:mm:ss', true)
      if (!max.isValid()) {
        return this.maxStartDate
      }
      return max.format('YYYY-MM-DD')
    },
    status_list_t() {
      return this.status_list.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
    event_list_t() {
      return this.event_list.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
    fleetData_t() {
      return this.fleetData.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  data() {
    return {
      detailedId: '',
      selected_plate: null,
      plate_array: [],
      selectedAlertId: '',
      selectedAlertImei: '',
      openModal: false,
      openModalDetail: false,
      titleModal: 'Add Notes',
      titleModalDetail: 'Add Notes',
      hideBtn: null,
      alert_array: [],
      fleet_array: [],
      event_list: [],
      fleetData: [],
      data: [],
      dataEdit: {},
      dataEditDetail: {},
      editMode: false,
      editModeDetail: false,
      filter_array: [],
      listPaired: [],
      s_alert: '',
      event_type: '',
      searchA: '',
      search_name: '',
      strips: [],
      dateStart: null,
      load_done: false,
      maxEnd: null,
      dateEnd: null,
      fleet_group_id: '',
      viewDetail: false,
      disableBtn: false,
      search: '',
      selected_filter: '',
      selected_fleet: '',
      currentPage: 1,
      last_page: 1,
      page: 1,
      itemsPerPage: 15,
      itemsPerPageArray: [
        {
          text: '15',
          value: 15,
        },
        {
          text: '30',
          value: 30,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
      ],
      sortBy: 'date',
      sortByArray: [
        {
          text: 'Date',
          value: 'date',
        },
        {
          text: 'License Plate',
          value: 'license_plate',
        },
        {
          text: 'Fleet Group',
          value: 'fleet_group_name',
        },
        {
          text: 'Alert',
          value: 'event_type',
        },
        {
          text: 'Speed',
          value: 'speed',
        },
        {
          text: 'RPM',
          value: 'engine_speed_x',
        },
        {
          text: 'Engine Temp',
          value: 'engine_coolant_temperature_x',
        },
        {
          text: 'Chiller Temp',
          value: 'dallas_temperature_1',
        },
      ],
      searchB: '',
      fleetGroup: '',

      status_list: [
        {
          text: 'All',
          value: '',
        },
        {
          text: 'Verified',
          value: 'verified',
        },
        {
          text: 'Not Yet Verified',
          value: 'not_yet_verified',
        },
        {
          text: 'Not Verified',
          value: 'unverified',
        },
      ],
      status_type: '',
      startDateInput: '',
      startTimeInput: '00:00',
      endDateInput: '',
      endTimeInput: '00:00',
      showTimePicker: false,
      currentTimeField: null,
      selectedHour: '00',
      selectedMinute: '00',
      hours: [],
      minutes: [],
      suppressStartInputWatcher: false,
      suppressEndInputWatcher: false,
    }
  },
  methods: {
    generateTimeOptions() {
      this.hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'))
      this.minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'))
    },
    openTimePicker(field) {
      this.currentTimeField = field
      const timeValue = field === 'start' ? this.startTimeInput : this.endTimeInput
      const [hour = '00', minute = '00'] = (timeValue || '00:00').split(':')
      this.selectedHour = hour
      this.selectedMinute = minute
      this.showTimePicker = true
      this.$nextTick(() => {
        this.scrollToSelected()
      })
    },
    closeTimePicker() {
      this.showTimePicker = false
      this.currentTimeField = null
    },
    selectHour(hour) {
      this.selectedHour = hour
    },
    selectMinute(minute) {
      this.selectedMinute = minute
    },
    scrollToSelected() {
      const hourScroll = this.$refs.hourScroll
      const minuteScroll = this.$refs.minuteScroll

      if (hourScroll) {
        const hourIndex = this.hours.indexOf(this.selectedHour)
        if (hourIndex >= 0) {
          hourScroll.scrollTop = Math.max(hourIndex * 40 - 80, 0)
        }
      }

      if (minuteScroll) {
        const minuteIndex = this.minutes.indexOf(this.selectedMinute)
        if (minuteIndex >= 0) {
          minuteScroll.scrollTop = Math.max(minuteIndex * 40 - 80, 0)
        }
      }
    },
    confirmTime() {
      const time = `${this.selectedHour}:${this.selectedMinute}`

      if (this.currentTimeField === 'start') {
        this.startTimeInput = time
      } else if (this.currentTimeField === 'end') {
        this.endTimeInput = time
      }

      this.closeTimePicker()
    },
    syncStartInputsFromDate(val) {
      this.suppressStartInputWatcher = true

      if (!val) {
        this.startDateInput = ''
        this.startTimeInput = '00:00'
      } else {
        const parsed = moment(val, 'YYYY-MM-DD HH:mm:ss', true)
        const momentValue = parsed.isValid() ? parsed : moment(val)

        if (momentValue.isValid()) {
          this.startDateInput = momentValue.format('YYYY-MM-DD')
          this.startTimeInput = momentValue.format('HH:mm')
        } else {
          this.startDateInput = ''
          this.startTimeInput = '00:00'
        }
      }

      this.$nextTick(() => {
        this.suppressStartInputWatcher = false
      })
    },
    syncEndInputsFromDate(val) {
      this.suppressEndInputWatcher = true

      if (!val) {
        this.endDateInput = ''
        this.endTimeInput = '00:00'
      } else {
        const parsed = moment(val, 'YYYY-MM-DD HH:mm:ss', true)
        const momentValue = parsed.isValid() ? parsed : moment(val)

        if (momentValue.isValid()) {
          this.endDateInput = momentValue.format('YYYY-MM-DD')
          this.endTimeInput = momentValue.format('HH:mm')
        } else {
          this.endDateInput = ''
          this.endTimeInput = '00:00'
        }
      }

      this.$nextTick(() => {
        this.suppressEndInputWatcher = false
      })
    },
    updateStartFromInputs() {
      if (!this.startDateInput) {
        return
      }

      const time = this.startTimeInput || '00:00'
      let startMoment = moment(
        `${this.startDateInput} ${time}`,
        'YYYY-MM-DD HH:mm'
      )

      if (!startMoment.isValid()) {
        return
      }

      const minMoment = moment().subtract(4, 'months')
      const now = moment()

      if (startMoment.isBefore(minMoment)) {
        startMoment = minMoment
      }

      if (startMoment.isAfter(now)) {
        startMoment = now
      }

      const formatted = startMoment.format('YYYY-MM-DD HH:mm:ss')

      if (this.dateStart !== formatted) {
        this.dateStart = formatted
      }
    },
    updateEndFromInputs() {
      if (!this.endDateInput) {
        return
      }

      const time = this.endTimeInput || '00:00'
      let endMoment = moment(
        `${this.endDateInput} ${time}`,
        'YYYY-MM-DD HH:mm'
      )

      if (!endMoment.isValid()) {
        return
      }

      const startMoment = this.dateStart
        ? moment(this.dateStart, 'YYYY-MM-DD HH:mm:ss', true).isValid()
          ? moment(this.dateStart, 'YYYY-MM-DD HH:mm:ss', true)
          : moment(this.dateStart)
        : null

      if (startMoment && endMoment.isBefore(startMoment)) {
        endMoment = startMoment.clone()
      }

      const maxEndMoment = this.maxEnd
        ? moment(this.maxEnd, 'YYYY-MM-DD HH:mm:ss', true).isValid()
          ? moment(this.maxEnd, 'YYYY-MM-DD HH:mm:ss', true)
          : moment(this.maxEnd)
        : null

      if (maxEndMoment && endMoment.isAfter(maxEndMoment)) {
        endMoment = maxEndMoment.clone()
      }

      const formatted = endMoment.format('YYYY-MM-DD HH:mm:ss')

      if (this.dateEnd !== formatted) {
        this.dateEnd = formatted
      }
    },
    onKeyDownLicense(e) {
      //
      this.automateLicensePlate(e, e.target, this.strips)
    },
    deleteDetails() {
      const nodes = document.getElementsByClassName(
        'childDiv_' + this.detailedId
      )
      while (nodes[0]) {
        nodes[0].parentNode.removeChild(nodes[0])
      }
    },
    handleDetails(tr) {
      const self = this
      const div_id = tr._id
      if (this.detailedId == div_id) {
        const node = document.getElementsByClassName('childDiv_' + div_id)

        while (node[0]) {
          node[0].parentNode.removeChild(node[0])
        }
        this.detailedId = ''
        return
      } else {
        if (this.detailedId != '') {
          const prevnode = document.getElementsByClassName(
            'childDiv_' + this.detailedId
          )
          while (prevnode[0]) {
            prevnode[0].parentNode.removeChild(prevnode[0])
          }
          // prevnode.parentNode.removeChild(prevnode)
          createDropDown(
            tr.license_plate,
            tr.fleet_group_id,
            tr.event_type,
            tr.device_time
          )
        } else {
          createDropDown(
            tr.license_plate,
            tr.fleet_group_id,
            tr.event_type,
            tr.device_time
          )
        }
      }

      function createDropDown(
        license_plate,
        fleet_group_id,
        event_type,
        device_time
      ) {
        const date = moment(device_time).format('YYYY-MM-DD')
        //
        const param = {
          limit: -1,
          type: 'summary',
          license_plate: license_plate,
          fleet_group_id: fleet_group_id,
          event_type: event_type,
          start_date: date + ' 00:00',
          end_date: date + ' 23:59:59',
        }
        // create a placeholder while waiting for the data to load in
        const phChildDiv = document.createElement('tr')
        phChildDiv.style.backgroundColor = '#f5f5f5'
        phChildDiv.className = 'phchildDiv_' + div_id
        const phHeaderDivTd = document.createElement('td')
        // td span 5 col
        phHeaderDivTd.colSpan = 9
        phHeaderDivTd.style.padding = '0px'
        const phInsideDivTd = document.createElement('div')
        phInsideDivTd.classList.add('flex', 'items-center', 'justify-center')
        phInsideDivTd.style.backgroundColor = '#ffffff'
        phInsideDivTd.style.padding = '20px'
        phInsideDivTd.style.minHeight = '76px'
        phInsideDivTd.style.marginTop = '10px'
        phInsideDivTd.style.marginBottom = '10px'
        phInsideDivTd.innerHTML = `
          <div style="display: flex; align-items: center; gap: 12px;">
            <div class="loader_1"></div>
            <span style="color: #666; font-size: 14px; font-weight: 500;">Loading details...</span>
          </div>
        `
        phHeaderDivTd.appendChild(phInsideDivTd)
        phChildDiv.appendChild(phHeaderDivTd)
        const node = document.getElementById(div_id)
        node.parentNode.insertBefore(phChildDiv, node.nextSibling)

        REPO.getAlertHistory({
          ...param,
          alert_config: self.getRoleCode(),
        }).then(async (res) => {
          //
          // delete the placeholder
          const phNode = document.getElementsByClassName('phchildDiv_' + div_id)
          while (phNode[0]) {
            phNode[0].parentNode.removeChild(phNode[0])
          }

          const tmp = res.data.data.data
          //
          self.detailedId = div_id
          const node = document.getElementById(div_id)

          //

          processTmpArray()

          async function processTmpArray() {
            for (let index = 0; index < tmp.length; index++) {
              const x = tmp[index]
              const childDiv = document.createElement('tr')
              childDiv.style.backgroundColor = '#f5f5f5'
              childDiv.className = 'childDiv_' + div_id

              const type =
                x.verified_by !== undefined && x.verified_by !== ''
                  ? 'success'
                  : moment(x.device_time).isAfter(
                    moment().subtract(32, 'hours')
                  )
                    ? 'primary'
                    : moment(x.device_time).isAfter(
                      moment().subtract(64, 'hours')
                    )
                      ? 'warning'
                      : moment(x.device_time).isAfter(
                        moment().subtract(96, 'hours')
                      )
                        ? 'last-warning'
                        : 'danger'

              const header = [
                {
                  icon: 'AlertTriangleIcon',
                  date: moment(x.device_time).format('DD MMM'),
                  time: moment(x.device_time).format('HH:mm') + ' WIB',
                },
                x.license_plate,
                x.fleet_group_name,
                x.event_name,
                x.driver_name,
                x.driver_phone,
                x.speed + ' Km/h',
                self.getSimpleDurationV2(x.duration),
                {
                  latitude: x.latitude,
                  longitude: x.longitude,
                },
                {
                  name: x.verified_by,
                  type: type,
                  icon:
                    type == 'success'
                      ? 'CheckCircleIcon'
                      : type == 'danger'
                        ? 'XCircleIcon'
                        : 'AlertTriangleIcon',
                },
                x.note ? 'see notes' : '-',
                {
                  url: x.file_url,
                  type: x.file_type,
                  alarm_id_mettax: x.alarm_id_mettax
                }
              ]

              for (let i = 0; i < header.length; i++) {
                const headerDivTd = document.createElement('td')
                headerDivTd.style.padding = '0px'
                const insideDivTd = document.createElement('div')
                insideDivTd.classList.add('flex', 'items-center')
                insideDivTd.style.backgroundColor = '#ffffff'
                insideDivTd.style.padding = '10px'
                insideDivTd.style.minHeight = '76px'

                insideDivTd.style.marginTop = '0px'
                insideDivTd.style.marginBottom = '0px'
                if (index === 0) {
                  insideDivTd.style.marginTop = '10px'
                }
                if (index === tmp.length - 1) {
                  insideDivTd.style.marginBottom = '10px'
                }

                switch (i) {
                  case 0:
                    const wrapperDate = document.createElement('div')
                    wrapperDate.classList.add('flex', 'flex-col', 'text-left')

                    const text = document.createElement('p')
                    text.style.fontWeight = 'bold'
                    text.innerHTML = header[i].date

                    const text2 = document.createElement('p')
                    text2.style.fontSize = '12px'
                    text2.innerHTML = header[i].time

                    wrapperDate.appendChild(text)
                    wrapperDate.appendChild(text2)
                    insideDivTd.appendChild(wrapperDate)
                    break
                  case 8:
                    const wrapper = document.createElement('div')
                    wrapper.classList.add('flex', 'flex-col', 'text-left')

                    const parag = document.createElement('p')
                    parag.innerHTML = 'Loading address...'

                    const wrapper2 = document.createElement('div')
                    wrapper2.classList.add('flex', 'flex-row', 'text-left')

                    const loc = document.createElement('a')
                    loc.innerHTML = 'Show Google Map'
                    loc.href = `https://www.google.com/maps/search/?api=1&query=${header[i].latitude},${header[i].longitude}`
                    loc.setAttribute('target', '_blank')

                    const loc2 = document.createElement('a')
                    loc2.innerHTML = 'Show Street View'
                    loc2.href = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${header[i].latitude},${header[i].longitude}`
                    loc2.setAttribute('target', '_blank')

                    const divider = document.createElement('div')
                    divider.innerHTML = '&nbsp;|&nbsp;'

                    wrapper.appendChild(parag)
                    wrapper2.appendChild(loc)
                    wrapper2.appendChild(divider)
                    wrapper2.appendChild(loc2)
                    wrapper.appendChild(wrapper2)
                    insideDivTd.appendChild(wrapper)

                      // Fetch the address asynchronously
                      ; (async () => {
                        const address = (
                          await self.getAddress(
                            header[i].latitude,
                            header[i].longitude
                          )
                        ).display_name
                        parag.innerHTML = address
                      })()
                    break
                  case 9:
                    const verify = document.createElement('div')
                    insideDivTd.appendChild(verify)
                    break
                  case 10:
                    const noteP = document.createElement('p')
                    if (header[i] === 'see notes') {
                      noteP.classList.add(
                        'text-danger',
                        'underline',
                        'cursor-pointer'
                      )
                      noteP.addEventListener('click', function () {
                        self.handleSelectedAlert(x)
                      })
                    }
                    noteP.innerHTML = header[i]

                    const fileUrlDiv = document.createElement('div')
                    const fileUrlA = document.createElement('a')
                    if (header[11].type == "00") {
                      fileUrlA.href = header[11].url;
                      fileUrlA.target = "_blank";
                      fileUrlA.innerHTML = '<svg width="30" height="30" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"> <path d="M3.33333 14C2.96667 14 2.65289 13.8696 2.392 13.6087C2.13111 13.3478 2.00044 13.0338 2 12.6667V3.33333C2 2.96667 2.13067 2.65289 2.392 2.392C2.65333 2.13111 2.96711 2.00044 3.33333 2H12.6667C13.0333 2 13.3473 2.13067 13.6087 2.392C13.87 2.65333 14.0004 2.96711 14 3.33333V12.6667C14 13.0333 13.8696 13.3473 13.6087 13.6087C13.3478 13.87 13.0338 14.0004 12.6667 14H3.33333ZM4.66667 11.3333H11.3333C11.4667 11.3333 11.5667 11.2722 11.6333 11.15C11.7 11.0278 11.6889 10.9111 11.6 10.8L9.76667 8.35C9.7 8.26111 9.61111 8.21667 9.5 8.21667C9.38889 8.21667 9.3 8.26111 9.23333 8.35L7.5 10.6667L6.26667 9.01667C6.2 8.92778 6.11111 8.88333 6 8.88333C5.88889 8.88333 5.8 8.92778 5.73333 9.01667L4.4 10.8C4.31111 10.9111 4.3 11.0278 4.36667 11.15C4.43333 11.2722 4.53333 11.3333 4.66667 11.3333Z" fill="#EE6D6D"/></svg>';
                    } else if (header[11].type == "02") {
                      fileUrlA.href = header[11].url;
                      fileUrlA.target = "_blank";
                      fileUrlA.innerHTML = '<svg width="30" height="30" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12C6.78793 12 7.56815 11.8448 8.2961 11.5433C9.02405 11.2417 9.68549 10.7998 10.2426 10.2426C10.7998 9.68549 11.2417 9.02405 11.5433 8.2961C11.8448 7.56815 12 6.78793 12 6C12 5.21207 11.8448 4.43185 11.5433 3.7039C11.2417 2.97595 10.7998 2.31451 10.2426 1.75736C9.68549 1.20021 9.02405 0.758251 8.2961 0.456723C7.56815 0.155195 6.78793 -1.17411e-08 6 0C4.4087 2.37122e-08 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM5.18867 3.32667L8.95133 5.41733C9.05521 5.47509 9.14176 5.55956 9.20202 5.66201C9.26227 5.76445 9.29405 5.88115 9.29405 6C9.29405 6.11885 9.26227 6.23555 9.20202 6.33799C9.14176 6.44044 9.05521 6.52491 8.95133 6.58267L5.18867 8.67333C5.06683 8.74105 4.92942 8.77577 4.79004 8.77403C4.65066 8.77229 4.51416 8.73417 4.39405 8.66344C4.27394 8.59271 4.17439 8.49182 4.10527 8.37078C4.03616 8.24973 3.99987 8.11272 4 7.97333V4.02667C3.99987 3.88728 4.03616 3.75027 4.10527 3.62923C4.17439 3.50818 4.27394 3.40729 4.39405 3.33656C4.51416 3.26583 4.65066 3.22771 4.79004 3.22597C4.92942 3.22423 5.06683 3.25895 5.18867 3.32667Z" fill="#EE6D6D"/>/svg>';
                    }

                    if (header[11].alarm_id_mettax != '') {
                      function createLink(text, url) {
                        const link = document.createElement("a");
                        link.innerHTML = text;
                        link.target = "_blank";
                        link.href = url;
                        link.classList.add(
                          // "vs-component",
                          // "vs-button",
                          // "py-2",
                          // "px-4",
                          // "btn-download",
                          // "vs-button-danger",
                          // "vs-button-border"
                        );
                        return link;
                      }

                      // Buat container div untuk menampung link dalam grid
                      const linkContainer = document.createElement("div");
                      linkContainer.style.display = "grid";
                      linkContainer.style.gridTemplateColumns = "repeat(2, auto)"; // 2 kolom
                      linkContainer.style.gap = "8px";

                      // Fetch MettaX data with proper error handling
                      try {
                        const token = await REPO.getMettaXToken()
                          .then((res) => res.data.data)
                          .catch(err => {
                            console.error('Failed to get MettaX token:', err)
                            return null
                          })

                        if (token) {
                          const alarmS = await REPO.mettaXAlertByAlarmId(token, { "alarmId": x.alarm_id_mettax })
                            .then((res) => res.data.data || [])
                            .catch(err => {
                              console.error('Failed to get MettaX alerts:', err)
                              return []
                            })

                          for (const alarm of alarmS) {
                            let type
                            if (alarm.fileType == "00") {
                              type = '<svg width="30" height="30" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"> <path d="M3.33333 14C2.96667 14 2.65289 13.8696 2.392 13.6087C2.13111 13.3478 2.00044 13.0338 2 12.6667V3.33333C2 2.96667 2.13067 2.65289 2.392 2.392C2.65333 2.13111 2.96711 2.00044 3.33333 2H12.6667C13.0333 2 13.3473 2.13067 13.6087 2.392C13.87 2.65333 14.0004 2.96711 14 3.33333V12.6667C14 13.0333 13.8696 13.3473 13.6087 13.6087C13.3478 13.87 13.0338 14.0004 12.6667 14H3.33333ZM4.66667 11.3333H11.3333C11.4667 11.3333 11.5667 11.2722 11.6333 11.15C11.7 11.0278 11.6889 10.9111 11.6 10.8L9.76667 8.35C9.7 8.26111 9.61111 8.21667 9.5 8.21667C9.38889 8.21667 9.3 8.26111 9.23333 8.35L7.5 10.6667L6.26667 9.01667C6.2 8.92778 6.11111 8.88333 6 8.88333C5.88889 8.88333 5.8 8.92778 5.73333 9.01667L4.4 10.8C4.31111 10.9111 4.3 11.0278 4.36667 11.15C4.43333 11.2722 4.53333 11.3333 4.66667 11.3333Z" fill="#EE6D6D"/></svg>';
                            } else {
                              type = '<svg width="30" height="30" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12C6.78793 12 7.56815 11.8448 8.2961 11.5433C9.02405 11.2417 9.68549 10.7998 10.2426 10.2426C10.7998 9.68549 11.2417 9.02405 11.5433 8.2961C11.8448 7.56815 12 6.78793 12 6C12 5.21207 11.8448 4.43185 11.5433 3.7039C11.2417 2.97595 10.7998 2.31451 10.2426 1.75736C9.68549 1.20021 9.02405 0.758251 8.2961 0.456723C7.56815 0.155195 6.78793 -1.17411e-08 6 0C4.4087 2.37122e-08 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM5.18867 3.32667L8.95133 5.41733C9.05521 5.47509 9.14176 5.55956 9.20202 5.66201C9.26227 5.76445 9.29405 5.88115 9.29405 6C9.29405 6.11885 9.26227 6.23555 9.20202 6.33799C9.14176 6.44044 9.05521 6.52491 8.95133 6.58267L5.18867 8.67333C5.06683 8.74105 4.92942 8.77577 4.79004 8.77403C4.65066 8.77229 4.51416 8.73417 4.39405 8.66344C4.27394 8.59271 4.17439 8.49182 4.10527 8.37078C4.03616 8.24973 3.99987 8.11272 4 7.97333V4.02667C3.99987 3.88728 4.03616 3.75027 4.10527 3.62923C4.17439 3.50818 4.27394 3.40729 4.39405 3.33656C4.51416 3.26583 4.65066 3.22771 4.79004 3.22597C4.92942 3.22423 5.06683 3.25895 5.18867 3.32667Z" fill="#EE6D6D"/>/svg>';
                            }

                            linkContainer.appendChild(createLink(type, alarm.fileUrl));
                          }
                        }
                      } catch (error) {
                        console.error('Error fetching MettaX data:', error)
                        // Jika error, tetap lanjutkan tanpa data MettaX
                      }
                      
                      insideDivTd.appendChild(linkContainer);
                    }

                    fileUrlDiv.classList.add("p-2")

                    fileUrlDiv.appendChild(fileUrlA);
                    noteP.appendChild(fileUrlDiv);
                    insideDivTd.append(noteP)
                    break
                  default:
                    insideDivTd.innerHTML = self.$t(header[i])
                    break
                }

                headerDivTd.appendChild(insideDivTd)
                childDiv.appendChild(headerDivTd)
              }

              let currNode = node.nextSibling
              for (let j = 0; j < index; j++) {
                currNode = currNode.nextSibling
              }
              node.parentNode.insertBefore(childDiv, currNode)
            }
          }
        }).catch((error) => {
          // Handle error and remove placeholder
          const phNode = document.getElementsByClassName('phchildDiv_' + div_id)
          while (phNode[0]) {
            phNode[0].parentNode.removeChild(phNode[0])
          }
          
          // Show error message
          const errorDiv = document.createElement('tr')
          errorDiv.style.backgroundColor = '#f5f5f5'
          errorDiv.className = 'childDiv_' + div_id
          const errorTd = document.createElement('td')
          errorTd.colSpan = 9
          errorTd.style.padding = '0px'
          const errorContent = document.createElement('div')
          errorContent.classList.add('flex', 'items-center', 'justify-center')
          errorContent.style.backgroundColor = '#ffffff'
          errorContent.style.padding = '20px'
          errorContent.style.minHeight = '76px'
          errorContent.style.marginTop = '10px'
          errorContent.style.marginBottom = '10px'
          errorContent.innerHTML = `
            <span style="color: #EE6D6D; font-size: 14px; font-weight: 500;">Failed to load details. Please try again.</span>
          `
          errorTd.appendChild(errorContent)
          errorDiv.appendChild(errorTd)
          const node = document.getElementById(div_id)
          node.parentNode.insertBefore(errorDiv, node.nextSibling)
        })
      }
    },
    getFilterData() {
      this.fleet_group_id = this.$dataLocal.UserData().id
      REPO.getFilterClusterLicVin(this.$dataLocal.UserData().id).then((res) => {
        if (res.data.status == 'true') {
          let arrays = res.data.data
          let license_plate = []
          // let imei = []
          // let vin = []
          // license_plate.push({text:'- LICENSE PLATE -', value:""});
          arrays.forEach((x) => {
            let license_plate_f = license_plate.some(
              (g) => g.value == x.vehicle_id
            )
            if (!license_plate_f)
              license_plate.push({ text: x.license_plate, value: x.vehicle_id })

            // let imei_f = imei.some((g) => g.value == x.imei)
            // if (!imei_f) imei.push({ text: x.imei, value: x.imei })

            // let vin_f = vin.some((g) => g.value == x.vehicle_number)
            // if (!vin_f)
            //   vin.push({ text: x.vehicle_number, value: x.vehicle_number })
          })
          // this.imei_array = imei

          // this.vin_array = vin
          this.plate_array = [...license_plate]
        } else {
        }
      })
    },
    handleFilterClick() {
      const endData = moment().format('YYYY-MM-DD HH:mm')
      const prevData = this.dateEnd
      setTimeout(() => {
        // this.maxEnd = endData
        this.dateEnd = prevData
      }, 100)
      // }
    },
    download_data() {
      // const self = this
      // var ProgressBar = require('progressbar.js')
      // var bar = new ProgressBar.Line('#loading-container', {
      //   strokeWidth: 1,
      //   easing: 'easeInOut',
      //   duration: 1400,
      //   borderRadius: '10px',
      //   color: 'rgba(234, 84, 85, 1)',
      //   trailColor: '#eee',
      //   trailWidth: 1,
      //   svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
      //   text: {
      //     style: {
      //       color: '#999',
      //       position: 'absolute',
      //       right: '0px',
      //       top: '30px',
      //       padding: 0,
      //       margin: 0,
      //       transform: null,
      //     },
      //     autoStyleContainer: false,
      //   },
      //   from: { color: '#FFEA82' },
      //   to: { color: '#ED6A5A' },
      //   step: (state, bar) => {
      //     let value = Math.round(bar.value() * 100)
      //     if (value >= 100) {
      //       bar.setText('Writing Excel file....')
      //     } else {
      //       bar.setText('Collecting Data ' + value + ' %')
      //     }
      //   },
      // })

      // bar.animate(0.0)

      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })

      const filename = `Summary_${this.event_type ? this.event_type : 'all'}(${moment(this.dateStart).format('YYYYMMDD') +
        '-' +
        moment(this.dateEnd).format('YYYYMMDD')
        })${this.$dataLocal.UserData().id.split('-')[0]}${moment().valueOf()}`

      this.loadingBtnStart('btn-download')
      const param = {
        type: 'local',
        start_date: moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss'),
        title: filename,
        file_export: 'summary',
        status_verified: this.status_type,
      }

      // const rowsToDownload = this.last_page * this.itemsPerPage * 10 // Total number of rows to download
      // const averageTimePerRow = (2.4 * 60 * 1000) / 33375 // Average time per row in milliseconds based on your observation
      // const totalDownloadDuration = rowsToDownload * averageTimePerRow // Total download duration in milliseconds
      // const intervalTime = 200 // Interval time in milliseconds
      // const totalSteps = totalDownloadDuration / intervalTime
      // const increment = 1 / totalSteps

      // let currentProgress = 0

      // const interval = setInterval(() => {
      //   currentProgress += increment
      //   bar.animate(currentProgress)
      //   if (currentProgress >= 1) {
      //     bar.set(1) // Ensure the bar value is exactly 1
      //     clearInterval(interval)
      //   }
      // }, intervalTime)

      //
      if (this.event_type !== '') {
        param.event_types = [this.event_type]
      } else {
        param.event_types = JSON.parse(this.getRoleCode())
      }

      const user_id = this.$dataLocal.UserData().id

      if (this.selected_fleet === user_id) {
        const fgids = JSON.parse(this.$dataLocal.UserData().fleet_group_ids)
        param.fleet_group_ids = fgids
      } else {
        param.fleet_group_ids = [this.selected_fleet]
      }
      delete param.license_plate

      if (this.selected_plate != null) {
        param.license_plate = [this.selected_plate.text]
        delete param.fleet_group_ids
      }

      REPO.exportSenderV2(param)
        .then((res) => {
          this.$router.push('/export/history')
          //
          // if (res.data.status == true) {
          //   const urlData = res.data.data
          //   this.download(urlData, filename)
          // }
        })
        .catch((err) => {
          this.$toast.error('Problem Exporting Data')
        })
        .finally(() => {
          // bar.animate(1.0)
          // setTimeout(() => {
          //   clearInterval(interval)
          //   bar.destroy()
          // }, 500)
          this.loadingBtnStop('btn-download')
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
        })
    },
    download(dataurl, filename) {
      const link = document.createElement('a')
      link.href = dataurl
      link.download = filename
      link.click()
    },
    submitModal() {
      this.openModal = false
      this.editMode = false

      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    checkSuhu(val) {
      let tmp = val
      if (parseInt(val) > 99) {
        tmp = Math.round(parseInt(val) / 10)
      }
      return tmp
    },
    resetData() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      let start = moment().format('YYYY-MM-DD') + ' 00:00:00'
      this.dateStart = start
      let ends = moment().format('YYYY-MM-DD HH:mm')
      this.dateEnd = ends
      this.event_type = ''
      this.page = 1
      this.selected_fleet = this.$dataLocal.UserData().id
      this.search_name = ''
      //
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    getByCurrentPage() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.event_type = ''
      this.selected_fleet = this.$dataLocal.UserData().id
      this.search_name = ''
      let param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }
      //
      this.getData(param)
    },
    searchData() {
      //
      this.deleteDetails()

      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      //
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })
    },
    showDataCount(val) {
      //
      this.itemsPerPage = val
      this.searchData()
    },
    filterData() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })

      this.detailedId = ''
    },
    rekursive(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = text + (parseInt(counter) + 1) + ' ' + x.fleet_group_name
        let tmp = {
          text: text,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    refreshData() {
      //
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      //
      let end_date = moment().format('YYYY-MM-DD HH:mm:ss')
      this.maxEnd = end_date
      this.dateEnd = end_date

      const param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }
      this.getData(param)
    },
    getData(param) {
      this.deleteDetails()

      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      // param.limit = this.itemsPerPage
      if (this.event_type == '') delete param.event_type
      if (this.license_plate == '') delete param.license_plate

      REPO.getAlertSummary({ ...param, alert_config: this.getRoleCode() })
        .then(async (res) => {
          let tmp = res.data.data.data

          if (tmp == null || tmp == undefined || tmp.length == 0) {
            this.data = []
            this.$vs.loading.close('#isi_table > .con-vs-loading')
            this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            return
          }
          tmp.map((x) => {
            const type =
              x.verified_by != undefined && x.verified_by != ''
                ? 'success'
                : moment(x.device_time).isAfter(moment().subtract(32, 'hours'))
                  ? 'primary'
                  : moment(x.device_time).isAfter(
                    moment().subtract(64, 'hours')
                  )
                    ? 'warning'
                    : moment(x.device_time).isAfter(
                      moment().subtract(96, 'hours')
                    )
                      ? 'last-warning'
                      : 'danger'
            x.verified_by = {
              name: x.verified_by,
              type: type,
              icon:
                type == 'success'
                  ? 'CheckCircleIcon'
                  : type == 'danger'
                    ? 'XCircleIcon'
                    : 'AlertTriangleIcon',
            }
            x.gmaps_url = `https://www.google.com/maps/search/?api=1&query=${x.latitude},${x.longitude}`
            x.streetview_url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${x.latitude},${x.longitude}`
          })
          this.last_page = res.data.data.last_page
          this.data = tmp
          //

          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
          this.load_done = true
        })
        .catch((err) => {
          //
        })
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)
      //
      return tmp.data
    },
    signInFirebase() {
      firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          //
        })
    },
    handleSelected(tr) {
      //
      if (tr.verified_by.type == 'danger') {
        this.$toast.error(`This data is expired and can not be verified!`, {
          duration: 3000,
        })
        return
      } else if (tr.verified_by.type == 'success') {
        return
      }
      // this.editMode = true
      this.selectedAlertId = tr._id
      this.selectedAlertImei = tr.imei
      this.editMode = true
      this.titleModal = 'Add Notes Summary'
      tr.start_date = this.dateStart
      tr.end_date = this.dateEnd
      // ))
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      //
      this.openModal = true
      //
    },
    handleSelectedAlert(tr) {
      if (tr.verified_by.type == 'danger') {
        this.$toast.error(`This data is expired and can not be verified!`, {
          duration: 3000,
        })
        return
      }
      // this.editMode = true
      this.selectedAlertId = tr._id
      this.selectedAlertImei = tr.imei
      this.editModeDetail = true
      this.titleModalDetail = 'Add Notes Urgent'
      this.dataEditDetail = JSON.parse(JSON.stringify(tr))
      //
      this.openModalDetail = true
      //
    },
    formatDate(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    },
    closeModal() {
      this.openModal = false
      this.openModalDetail = false
      this.editMode = false
      this.editModeDetail = false
      // this.openBulkModal = false
      // this.confirmDelete = false
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.listPaired = []
      this.fleetGroup = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
  },
}
</script>
<style>
:root {
  --primary: rgba(123, 168, 255, 0.1);
  --warning: rgba(248, 190, 41, 0.1);
  --last-warning: rgba(242, 153, 74, 0.1);
  --danger: rgba(235, 87, 87, 0.1);
  --success: rgba(58, 151, 76, 0.1);
  --primary-content: rgba(123, 168, 255, 1);
  --warning-content: rgba(248, 190, 41, 1);
  --last-warning-content: rgba(242, 153, 74, 1);
  --danger-content: rgba(235, 87, 87, 1);
  --success-content: rgba(58, 151, 76, 1);
}

.loader_1 {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

.datepicker {
  right: 0;
}

.datetimepicker>.flex {
  display: none !important;
}

.visible>.flex {
  display: flex !important;
}

.date-popup>.vs-popup>.vs-popup--content {
  overflow: visible;
}

.heights {
  width: 100%;
  height: calc(100vh - 15.1rem);
}

.custom-search {
  position: absolute;
  width: 50%;
  right: 7px;
  top: 2px;
  z-index: 3;
}

.cursor {
  cursor: pointer;
}

#data-list-list-view > div.vs-row > div > div > nav > ul > li{
  margin: 0px 10px;
}

.custom-datetime-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.custom-date-input {
  flex: 1;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fff;
  font-size: 0.9rem;
}

.custom-time-picker {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  min-width: 90px;
  background-color: #fff;
  transition: border-color 0.2s ease;
}

.custom-time-picker:hover {
  border-color: #ea5455;
}

.time-display {
  font-weight: 600;
  color: #374151;
}

.clock-icon {
  color: #6b7280;
}

.time-picker-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.time-picker-modal {
  width: 320px;
  max-width: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.time-picker-header {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}

.time-picker-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
}

.time-picker-body {
  padding: 16px 20px;
}

.time-scroll-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
}

.time-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.time-column-header {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.time-scroll {
  height: 200px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  padding: 4px;
}

.time-scroll::-webkit-scrollbar {
  width: 6px;
}

.time-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.time-scroll::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.time-scroll::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.time-item {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.15s ease;
  user-select: none;
  font-family: 'Courier New', monospace;
}

.time-item:hover {
  background: #e5e7eb;
  color: #111827;
}

.time-item.active {
  background: #ea5455;
  color: #ffffff;
  box-shadow: 0 2px 10px rgba(234, 84, 85, 0.35);
}

.time-separator {
  font-size: 28px;
  font-weight: 600;
  color: #ea5455;
  font-family: 'Courier New', monospace;
  margin-top: 28px;
}

.time-picker-footer {
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.time-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.time-btn.time-btn-cancel {
  background: #f3f4f6;
  color: #374151;
}

.time-btn.time-btn-cancel:hover {
  background: #e5e7eb;
}

.time-btn.time-btn-confirm {
  background: #ea5455;
  color: #ffffff;
}

.time-btn.time-btn-confirm:hover {
  background: #d13f41;
  box-shadow: 0 4px 12px rgba(234, 84, 85, 0.35);
}
</style>
